import MuiContainer from 'components/MuiExtras/MuiContainer';
import MuiWidgetTitle from 'components/MuiExtras/MuiWidgetTitle';
import MuiColor from 'components/MuiExtras/Typography/MuiColor';
import { FeedTopicStatisticsDto } from 'models/ApiModels';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    data: FeedTopicStatisticsDto;
}

type Props = IProps;

/////////////////////////////////////////////////////////////////////////////////////////////////////////////


const TopicResumeWidget: React.FC<Props> = (props) => {
    const { t } = useTranslation();
    const { data } = props;

    return (
        <MuiContainer margin="dense">

            <MuiWidgetTitle title={t("Views.Topic.Widgets.TopicResumeWidget.BoxTitle")} />

            <MuiColor variant="muted">
                <MuiContainer margin="dense">
                    <table>
                        <tbody>
                            <tr>
                                <td align="right"><span>{data.publications}</span></td>
                                <td><span>{t("Views.Topic.Widgets.TopicResumeWidget.PublicationText", { count: data.publications })}</span></td>
                            </tr>
                            <tr>
                                <td align="right"><span>{data.followers}</span></td>
                                <td><span>{t("Views.Topic.Widgets.TopicResumeWidget.FollowerText", { count: data.followers })}</span></td>
                            </tr>
                        </tbody>
                    </table>
                </MuiContainer>
            </MuiColor>

        </MuiContainer >

    );
};

export default TopicResumeWidget;